import React, { ForwardedRef, useImperativeHandle, useRef } from 'react';
import Chart from '..';
import { BarChartProps, ChartRef } from '../_config/interface';
import { makeupOptions } from '../_config/utils';

const BarChartInner: React.ForwardRefRenderFunction<ChartRef, BarChartProps> = (
  props,
  ref: ForwardedRef<ChartRef>,
) => {
  const {
    className = '',
    style = {},
    height,
    chartEventConfig,
    notMerge,
    barOption,
    showBarPeiName,
    chartType,
    barLengend,
  } = props;
  const chartRef = useRef<ChartRef>(null);
  const option = makeupOptions(props, 'bar');

  // 获取实例
  const instance = () => {
    return chartRef?.current?.instance();
  };

  // 对父组件暴露的方法
  useImperativeHandle(ref, () => ({
    instance,
  }));

  const chartStyle = {
    ...(height ? { height: `${height}px` } : {}),
    width: '100%',
    ...style,
  };

  return (
    <div className={`chart-box ${className}`} style={chartStyle}>
      <Chart
        ref={chartRef}
        option={barOption ? barOption : option}
        chartEventConfig={chartEventConfig}
        notMerge={notMerge}
        showBarPeiName={showBarPeiName}
        chartType={chartType}
      />
      {barLengend ? barLengend : null}
    </div>
  );
};

const BarChart = React.forwardRef(BarChartInner);

export default BarChart;
